import { render, staticRenderFns } from "./PannelloTecniciComponente.vue?vue&type=template&id=3f7dfb10&"
import script from "./PannelloTecniciComponente.vue?vue&type=script&lang=js&"
export * from "./PannelloTecniciComponente.vue?vue&type=script&lang=js&"
import style0 from "./PannelloTecniciComponente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports